import mongoose from 'mongoose';

const { Schema } = mongoose;

const PendingResetSchema = new Schema({
  unique_id: { type: String },
  used: { type: Boolean },
});

export default () => mongoose.model('pendingreset', PendingResetSchema, 'PendingReset');
